// 拖放的資料型別：樹上的設備 → 影像牆格位；節點 / 檢視 / 群組 → 影像牆（依版面自動分頁）。
export const DND_CAM = 'application/x-kinio-cam';
/** 資料 = JSON {key: 範圍鍵, label: 名稱} */
export const DND_SCOPE = 'application/x-kinio-scope';
